<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'CrewReservations',
  };
</script>

<style scoped>

</style>